@if (isDisabled) {
  <nb-form-field>
    <input nbInput
           [fieldSize]="size()"
           type="text"
           [placeholder]="placeholder()"
           [ngModel]="selectedNames()"
           fullWidth
           [disabled]="true" />
  </nb-form-field>
} @else {
  <nb-form-field>
    <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
    <input nbInput
           type="text"
           [fieldSize]="size()"
           [ngModel]="filterText()" (ngModelChange)="filterText.set($event)"
           [placeholder]="placeholder()"
           [nbPopover]="popoverTemplate"
           [nbPopoverPlacement]="'bottom-end'"
           [nbPopoverTrigger]="'focus'"
           fullWidth />
  </nb-form-field>

  @if (selectedTenants().length) {
    <div class="selected-chips">
      @for (tenant of selectedTenants(); track tenant.id) {
        <div class="chip">
          <nb-icon pack="fas" [icon]="tenantIcon(tenant.type)"></nb-icon>
          <span class="chip-name">{{ tenant.name }}</span>
          <button type="button" nbButton ghost size="tiny"
                  (mousedown)="$event.preventDefault()"
                  (click)="removeSelection(tenant.id)">
            <nb-icon icon="close-outline" pack="eva"></nb-icon>
          </button>
        </div>
      }
    </div>
  }

  <ng-template #popoverTemplate>
    <div class="autocomplete-dropdown">
      <nb-list nbInfiniteList (bottomThreshold)="loadMore()" [threshold]="50" [throttleTime]="100">
        @for (tenant of tenants(); track tenant.id) {
          <nb-list-item
            (mousedown)="$event.preventDefault()"
            (click)="toggleSelection(tenant)">
            <div class="tenant" [class.selected]="isSelected(tenant.id)">
              <nb-icon pack="fas" [icon]="tenantIcon(tenant.type)"></nb-icon>
              <span class="tenant-name">{{ tenant.name }}</span>
              <span class="tenant-type">({{ tenantTypePipe.transform(tenant.type) }})</span>
              @if (isSelected(tenant.id)) {
                <nb-icon class="check-icon" icon="checkmark-outline" pack="eva"></nb-icon>
              }
            </div>
          </nb-list-item>
        }
      </nb-list>
    </div>
  </ng-template>
}
